import { List } from "immutable";

export default {
  plots: [],
  pageable: {},
  features: List(),
};
